"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icone = require("../elements/Icone");

var _Icone2 = _interopRequireDefault(_Icone);

require("../../assets/css/components/perfil/perfil-navegacao.css");

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PerfilNavegacao = function (_Component) {
    _inherits(PerfilNavegacao, _Component);

    function PerfilNavegacao() {
        _classCallCheck(this, PerfilNavegacao);

        return _possibleConstructorReturn(this, (PerfilNavegacao.__proto__ || Object.getPrototypeOf(PerfilNavegacao)).apply(this, arguments));
    }

    _createClass(PerfilNavegacao, [{
        key: "onClick",
        value: function onClick(event) {
            if (!this.props.linkToPerfil) event.preventDefault();
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "header",
                { className: "box-usuario", role: "heading" },
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: this.props.linkToPerfil || '#', tabIndex: 0, "aria-label": "Acessar perfil do Usuário:" + this.props.username + " com Perfil de:" + this.props.grupo, onClick: this.onClick.bind(this) },
                    _react2.default.createElement(
                        "div",
                        { className: "usuario", "aria-hidden": "true" },
                        this.props.imagem ? _react2.default.createElement("div", { id: "imagem-perfil", alt: "Im\xE1gem do Usu\xE1rio", "aria-hidden": "true", style: { backgroundImage: "url(" + this.props.imagem + ")" } }) : _react2.default.createElement(_Icone2.default, { icone: "account_circle", tamanho: "1.7" }),
                        _react2.default.createElement(
                            "div",
                            { className: "usuario-info" },
                            _react2.default.createElement(
                                "span",
                                { className: "usuario-nome" },
                                this.props.username
                            ),
                            _react2.default.createElement(
                                "small",
                                { className: "usuario-grupo" },
                                this.props.grupo
                            )
                        )
                    )
                )
            );
        }
    }]);

    return PerfilNavegacao;
}(_react.Component);

exports.default = PerfilNavegacao;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/perfil/PerfilNavegacao.js
// module id = 1133
// module chunks = 0